import {
  BORDER_RADIUS,
  COLORS,
  DEVICE_TYPE,
  MARGIN,
  SIZE,
} from "constants/variables";
import styled from "styled-components";
import cursorIcon from "assets/img/Cursor.png";
import { ReactComponent as ReportsIcon } from "assets/svg/ActivityReportsIcon.svg";
import { ReactComponent as OpenFolderIcon } from "assets/svg/OpenFolderIcon.svg";

export const ActivityReportsContainer = styled.div`
  width: 100%;
  margin-top: 150px;
  padding: 0px ${SIZE.max240};
  display: flex;
  flex-direction: column;
  @media (max-width: ${DEVICE_TYPE.largeDesktop}) {
    padding: 0px ${SIZE.max100};
  }
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    padding: 0px ${SIZE.max80};
  }
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding: 0px ${SIZE.max32};
  }
`;

export const LeftSideContainer = styled.div`
  width: 100%;
`;

export const TitleSectionWrapper = styled.div``;

export const BackToWrapper = styled.div<{ biggerCursor?: boolean }>`
  cursor: ${({ biggerCursor }) =>
    biggerCursor ? `url(${cursorIcon}), auto` : `pointer`};
  width: fit-content;
  transition: 0.3s ease-out;
  :hover {
    filter: brightness(0.7);
  }
`;

export const BackToGuidesImage = styled.img`
  margin-right: 8px;
  svg {
    width: 10px;
    height: 16px;
  }
  transform: rotate(90deg);
`;

export const BackToGuidesButton = styled.button`
  background-color: transparent;
  border: none;
  margin-bottom: ${MARGIN.max6};
  cursor: pointer;
`;

export const TitleWrapper = styled.div`
  margin-top: 8px;
  margin-bottom: 24px;
  display: flex;
  column-gap: ${SIZE.max10};
  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;

export const ActivityReportsContentCardContainer = styled.div`
  width: 100%;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.RaisinBlack};
  padding: ${SIZE.max55};
  display: flex;
  flex-direction: column;
  row-gap: ${SIZE.max24};
  max-height: 100%;

  @media (max-width: 1000px) {
    width: auto;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: auto;
  }
`;

export const RightSideContainer = styled.div`
  width: 100%;
  display: flex;
  padding: ${SIZE.max55};
  gap: ${SIZE.max24};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

export const ReportsSectionReportCardWrapper = styled.a`
  height: ${SIZE.max240};
  aspect-ratio: 1/1;
  border-radius: ${BORDER_RADIUS.radius24};
  background-color: ${COLORS.Cultured};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: ${SIZE.max32};
  border: 1px solid ${COLORS.AbsoluteWhite};
  transition: all 0.6s ease-in-out;
  text-decoration: none;
  :hover {
    background-color: ${COLORS.Background};
    cursor: pointer;
  }
`;
export const ReportsSectionReportCardTitleWrapper = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const ReportsSectionReportCardIconWrapper = styled.div``;

export const ReportsSectionReportCardIcon = styled(OpenFolderIcon)`
  height: ${SIZE.max60};
`;
